import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../Student/Reusablecomponents/Loading";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { FaRegEdit } from "react-icons/fa";
import AddInstitute from "./AddInstitute";
import { Alert } from "../../Student/Reusablecomponents/RegularFunctions";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
const InstitutionCount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Load, SetLoad] = useState(false);
  const [InstitueValues, setInstitueValues] = useState([]);
  const [OpenForm, CloseForm] = useState(false);
  const [EditInstitution, SetEditInstitution] = useState();

  const Institues = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/Institutes",
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      setInstitueValues(response.data);
    } catch (error) {
      console.error("Error fetching Institutes data:", error);
      return [];
    }
  };
  useEffect(() => {
    Institues();
  }, []);

  const AddInstituteForm = () => {
    CloseForm(!OpenForm);
    SetEditInstitution();
  };

  const handleEdit = (SingleInstitute) => {
    CloseForm(!OpenForm);
    SetEditInstitution(SingleInstitute);
  };
  const ViewInstituteHierarchy = (Row) => {
    navigate("/NCLAdmin/InstitutionMaster/InstituteHierarchy", {
      state: { InstId: Row?.instituteId, Instname: Row?.instituteName },
    });
  };

  const Columns = [
    {
      name: "Code",
      selector: "instituteCode",
      sortable: true,
    },
    {
      name: "Name",
      selector: "instituteName",
      sortable: false,
      cell: (Row) => (
        <div
          onClick={() => ViewInstituteHierarchy(Row)}
          title="Click to view Hierarchy values"
          // className="LinkStyles"
          style={{ color: "#4e4eff", cursor: "pointer" }}
        >
          {Row.instituteName}
        </div>
      ),
    },
    { name: "Address", selector: "address", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEdit
            title="Edit Institute Details"
            className="CPointer"
            onClick={() => {
              handleEdit(row);
            }}
            style={{ color: "#624DE3" }}
            size={18}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="TeacherBgImage">
        <div className="MainHeading" style={{ marginTop: "10px" }}>
          Institutes
        </div>
        <Alert />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <button className="Buttons AddButton dflex alignitems JCCenter gap-1" onClick={AddInstituteForm}>
            <HiMiniPlusSmall />
            Add Institute{" "}
          </button>
        </div>
        <DataTable
          data={InstitueValues}
          columns={Columns}
          className="NCLDataTable Card mt-3"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
        {/* <CopyRight /> */}
      </div>
      {Load && <Loading />}
      {OpenForm && (
        <div className="Model-Open">
          <AddInstitute
            Cancle={CloseForm}
            EditDetails={EditInstitution}
            GetList={Institues}
          />
        </div>
      )}
    </>
  );
};
export default InstitutionCount;
